import { useCookies } from 'react-cookie';
import psl from 'psl';
import collect from 'collect.js';

/** Registrable cookie domain for a hostname, falling back to 'localhost'. */
export function resolveCookieDomain(hostname) {
  return psl.parse(hostname).domain ?? 'localhost';
}

export default function useAppCookies(keys = []) {
  const [cookies, _setCookie, removeCookie] = useCookies(keys);

  return {
    cookies,
    getCookie: (key) => cookies[key] ?? null,
    setCookie: (key, value, options) =>
      _setCookie(key, value, {
        ...{
          domain: resolveCookieDomain(window.location.hostname),
          path: '/',
        },
        ...options,
      }),
    removeCookies: (keys) =>
      collect(keys)
        ?.each((key) => {
          removeCookie(key, {
            path: '/',
            domain: resolveCookieDomain(window.location.hostname),
          });
        })
        .all(),
  };
}
